/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class UiContentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUiContent
   */
  static readonly GetUiContentPath = '/content/{id}';

  /**
   * Get translatable UI content for a tenant page.
   *
   * Returns the merged UI content document containing translatable labels, dropdown values, and other page content for the CareFindr V3 frontend. The id path parameter is a hash token that maps to an internal page name. Sub-content files (e.g. lang-selector, specialty-dropdown) are auto-discovered and merged.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUiContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUiContent$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * BCP-47 language tag for translation resolution (e.g. en-us, es). Defaults to en-us.
     */
    'x-lang'?: string;

    /**
     * Page hash token that resolves to an internal page name.
     */
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, UiContentService.GetUiContentPath, 'get');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-lang', params['x-lang'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Get translatable UI content for a tenant page.
   *
   * Returns the merged UI content document containing translatable labels, dropdown values, and other page content for the CareFindr V3 frontend. The id path parameter is a hash token that maps to an internal page name. Sub-content files (e.g. lang-selector, specialty-dropdown) are auto-discovered and merged.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUiContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUiContent(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * BCP-47 language tag for translation resolution (e.g. en-us, es). Defaults to en-us.
     */
    'x-lang'?: string;

    /**
     * Page hash token that resolves to an internal page name.
     */
    id: string;
  },
  context?: HttpContext

): Observable<{
}> {

    return this.getUiContent$Response(params,context).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

}
